import { render, staticRenderFns } from "./AlertTemplate.vue?vue&type=template&id=6e9ddba4"
import script from "./AlertTemplate.vue?vue&type=script&lang=js"
export * from "./AlertTemplate.vue?vue&type=script&lang=js"
import style0 from "./AlertTemplate.vue?vue&type=style&index=0&id=6e9ddba4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports